import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png"
import { post } from "../../utils/helpers/http";
import { getLocalStorageData } from "../../utils/helpers/helpers";

const Header = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let authToken = getLocalStorageData("authorizationToken")
    if (!authToken) {
      console.log("navigate to root")
      navigate("/");
    }
  }, []);

  const handleLogout = async () => {
    try {
      const response = await post('/Account/Logout', { "a": "a" });
      if (response.status === 200) {
        localStorage.removeItem("accessToken")
        localStorage.removeItem("authorizationToken")
        localStorage.removeItem("userId")
        navigate("/");
      } else {
        if (response.response.status === 401) {
          navigate("/");
        }
      }
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/");
      }
    }
  };

  return (
    <nav className="navbar navbar-expand navbar-dark static-top">
      <div className="header-left">
        <span className="headerlogo">
          <img src={Logo} alt="logo" />
        </span>
        {/* <span className="main-header-menu-icon" id="sidebarToggle"><span></span></span> */}
      </div>
      <div className="header-right">
        <button className="logoutbtn" onClick={handleLogout}>Logout</button>
      </div>
    </nav>
  );
};

export default Header;
